import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { ResponsiveFlex } from "@narmi/design_system";
import { modules } from "byzantine";
import { WireTypeEnum } from "byzantine/src/dbbl/businessLogic/modules/internationalWires";
import Institution from "byzantine/src/Institution";
import { ContextForm } from "cerulean";
import WireTransferForm from "./form/WireTransferForm";
import { useSudoContext } from "../../SudoContext";

const WireTransfer = ({ limits, Header = /** @type {any} */ (undefined), setWireType }) => {
  const navigate = useNavigate();
  const { internationalWires } = modules.wireTemplates.useWirePermissions();
  const {
    onSetInitialSteps,
    formData,
    onFormDataChange: onChange,
    establishSudo,
    setDestinationRoute,
  } = useSudoContext();

  const goToTransferPage = () => {
    if (internationalWires) {
      setWireType(WireTypeEnum.None);
    } else {
      navigate("/transfer");
    }
  };

  const destinationRoute = "/transfer/wires/review";
  useEffect(() => {
    if (!formData?.recipient) {
      onChange({ recipient: {} });
    }
    setDestinationRoute(destinationRoute);
  }, []);

  useEffect(() => {
    onSetInitialSteps(3);
  }, [onSetInitialSteps]);

  const checkSudo = () => {
    new Institution().getSettings().then((settings) => {
      if (!settings.sudo_mode_required_for_wires) {
        navigate(destinationRoute);
        return;
      }
      establishSudo(destinationRoute);
    });
  };

  return (
    <ResponsiveFlex gapSize="xl">
      <ContextForm nativeForm={false} data={formData} onChange={onChange}>
        <WireTransferForm
          onSubmit={checkSudo}
          cancel={goToTransferPage}
          limits={limits}
          Header={Header}
        />
      </ContextForm>
    </ResponsiveFlex>
  );
};

WireTransfer.propTypes = {
  limits: PropTypes.object,
  Header: PropTypes.element,
  setWireType: PropTypes.func,
};

export default WireTransfer;
